import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { DialogComponent } from '../components/shared/dialog/dialog.component'
import { Dialog } from '@angular/cdk/dialog'
import { DialogOptions } from '../types/dialog'
import { ConfirmDialogComponent } from '../components/shared/confirm-dialog/confirm-dialog.component'
import { map, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor() {}

  confirmDialog(
    dialog: Dialog,
    header: string,
    message: string,
    labels?: { cancelText?: string; confirmText?: string },
  ): Observable<boolean> {
    return dialog
      .open<boolean>(ConfirmDialogComponent, {
        width: 'min(450px, calc(100vw - 32px))',
        data: { header, message, ...labels },
      })
      .closed.pipe(map((confirmed) => confirmed === true))
  }

  /**
   * Opens error dialog
   * @param {Dialog} dialog Dialog reference
   * @param {string} title The title of the modal
   * @param {string} message The message to display
   * @param {DialogOptions} options The dialog options
   */
  async showDialog(
    dialog: Dialog,
    title: string,
    message: string,
    options?: DialogOptions,
    router?: Router,
    link?: string,
  ): Promise<void> {
    const dialogRef = dialog.open<string>(DialogComponent, {
      width: options?.width || '550px',
      height: options?.height || 'fit-content',
      autoFocus: false,
      data: {
        title,
        message,
      },
    })

    dialogRef.closed.subscribe(() => {
      if ((router && link) || (router && link == '')) {
        router.navigate([link])
      }
    })
  }
}
